module.exports = __webpack_public_path__ + "img/BE0456038471.fabb3949.png";